import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { EnvironmentConfig } from '../config/environment.config';
import { PointsTotal } from '../models/points/points-total.model';

@Injectable({ providedIn: 'root' })
export class PointsService {
  constructor(@Inject('environment') private environment: EnvironmentConfig, private http: HttpClient) {}

  points(): Observable<PointsTotal> {
    return this.http.get<PointsTotal>(`${this.environment.endPoint}panel-member/points`);
  }
}
